"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.leadFlowDashBoard = leadFlowDashBoard;
var INITIAL_STATE = {};

function leadFlowDashBoard() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    default:
      return state;
  }
}